module.exports = __webpack_public_path__ + "img/18.f840bef1.png";